import { BulkRunFailure, BulkRunProgress } from '../../../utils/bulkRun';

export const ACCENT_SX = {
  bgcolor: 'v4.accent',
  '&:hover': { bgcolor: 'v4.accent', opacity: 0.9 },
};

/**
 * Progress and failure reporting, shared by every bulk action dialog. A
 * hundred records takes long enough that a bare spinner reads as a hang.
 */
export interface BulkRunProps {
  progress?: BulkRunProgress | null;
  failures?: BulkRunFailure[];
}
